// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1jaJp","label":"CategoryService_label__nNCQs","location":"CategoryService_location__9q0mp"};